<template>
  <AdminFieldWrapper>
    <v-textarea
      :value="value"
      :label="label"
      rows="3"
      v-on="$listeners"
      v-bind="{ ...$attrs }"
    />
  </AdminFieldWrapper>
</template>

<script>
import AdminFieldWrapper from '@/components/AdminFieldWrapper'
export default {
  name: 'AdminFieldTextarea',
  components: { AdminFieldWrapper },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {}
  },
}
</script>
